const REDIRECTS_MAP: Record<string, string> = {
  "liveauction.psg.fr": "https://www.mws.com/category/paris-saint-germain",
  "matchwornshirt.juventus.com": "https://www.mws.com/category/juventus",
  "maillots-portes.om.fr": "https://www.mws.com/category/olympique-marseille",
  "matchwornshirt.psv.nl": "https://www.mws.com/category/psv",
};

export default defineNuxtPlugin({
  name: "whitelabelRedirects",
  setup: async () => {
    const host = discoverHost();
    const redirectTo = REDIRECTS_MAP[host];

    if (!redirectTo) return;

    navigateTo(redirectTo, {
      redirectCode: 302,
      external: true,
    });
  },
});
